/**
 * Tipos internos da tela do RH doméstico.
 *
 * Papel: aqui fica `ColaboradorNoFormulario`, o formato que o react-hook-form
 * guarda, e o valor em branco de onde a criação parte.
 *
 * Ele é derivado dos schemas do contrato com `z.input`, e não escritos à
 * mão, porque é a entrada daqueles schemas que o formulário precisa produzir.
 */
import { type novoColaboradorSchema } from '@concierge/shared';
import { type z } from 'zod';

/** O colaborador como o formulário o guarda, antes de o schema normalizar. */
export type ColaboradorNoFormulario = z.input<typeof novoColaboradorSchema>;

/**
 * Um colaborador em branco, como o formulário de criação começa.
 *
 * `status` começa em `ativo` porque é o caso que se cadastra: ninguém registra
 * alguém já desligado com frequência. `residenciaId` começa vazio de propósito,
 * e o formulário não salva enquanto a escolha não for feita — um padrão faria a
 * pessoa nascer alocada à primeira casa da lista.
 */
export const COLABORADOR_EM_BRANCO: ColaboradorNoFormulario = {
  nomeCompleto: '',
  apelido: '',
  cpf: '',
  cargo: '',
  departamento: '',
  residenciaId: '',
  status: 'ativo',
  admissao: '',
  desligamento: '',
  salario: '',
  observacao: '',
};
